import React from 'react'

export default function DropDownDevider() {
    return (
        <div style={{ padding: '.25rem 1rem' }}>
            <hr className="dropdown-divider my-1" />
        </div>
    )
}
